"use strict";
export const VisitMock = (mock) => {
  mock.onGet("/api/v7/account/visit_list/black").reply((config) => {
    let response = {
      "model": "grid.result",
      "result": {
        "model": "data.set",
        "datas": [
          {
            "model": "virtualdesktop.blackwhite",
            "guid": "visitlist_5e4540875b0149159d5999ad10f56257",
            "name": "test2",
            "url": "https://www.google.com"
          },
          {
            "model": "virtualdesktop.blackwhite",
            "guid": "visitlist_bbc690f0ff554bd1a15f4a0bba51c320",
            "name": "test",
            "url": "https://www.baidu.com"
          }
        ],
        "total": 2
      },
      "page": {
        "model": "page",
        "current": 1,
        "total": 2,
        "size": 10
      }
    };
    return [200, response];
  });
};
